'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _I18nProvider2 = require('./I18nProvider');

var _I18nProvider3 = _interopRequireDefault(_I18nProvider2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var I18nWebProvider = function (_I18nProvider) {
    (0, _inherits3.default)(I18nWebProvider, _I18nProvider);

    function I18nWebProvider() {
        (0, _classCallCheck3.default)(this, I18nWebProvider);
        return (0, _possibleConstructorReturn3.default)(this, (I18nWebProvider.__proto__ || (0, _getPrototypeOf2.default)(I18nWebProvider)).apply(this, arguments));
    }

    (0, _createClass3.default)(I18nWebProvider, [{
        key: 'prepareGlobals',
        value: function prepareGlobals(localeData) {
            return _promise2.default.all([this.prepareFacebook(localeData.locale_fb), this.prepareGoogleMaps(localeData.locale_google)]);
        }
    }, {
        key: 'prepareGoogleMaps',
        value: function prepareGoogleMaps(locale) {
            if (this.props.googleMapsSdk === false) {
                return _promise2.default.resolve();
            }

            // Generate google maps localized script tag
            var googleMapsScript = document.getElementById('googlemapsscript');
            if (googleMapsScript) googleMapsScript.parentNode.removeChild(googleMapsScript);
            if (!_lodash2.default.isUndefined(window.google)) delete window.google.maps;
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://maps.googleapis.com/maps/api/js?client=gme-wixcomltd2' + '&libraries=places&callback=onGoogleDefined&language=' + locale;
            script.id = 'googlemapsscript';
            document.body.appendChild(script);

            // When the script is ready, it calls the global onGoogleDefined function
            return new _promise2.default(function (resolve) {
                window.onGoogleDefined = function () {
                    resolve();
                };
            });
        }
    }, {
        key: 'prepareFacebook',
        value: function prepareFacebook(locale) {
            var _this2 = this;

            if (this.props.fbJsSdk === false) {
                return _promise2.default.resolve();
            }

            // Generate facebook localized script tag
            var fbJsSdkElement = document.getElementById('facebook-jssdk');
            var fbRoot = document.getElementById('fb-root');

            if (fbJsSdkElement) fbJsSdkElement.parentNode.removeChild(fbJsSdkElement);
            if (fbRoot) fbRoot.parentNode.removeChild(fbRoot);

            if (!_lodash2.default.isUndefined(window.FB)) delete window.FB;

            // Load the SDK Asynchronously
            (function (d) {
                var js,
                    id = 'facebook-jssdk',
                    ref = d.getElementsByTagName('script')[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement('script');js.id = id;js.async = true;
                js.src = '//connect.facebook.net/' + locale + '/all.js';
                if (ref) ref.parentNode.insertBefore(js, ref);
            })(document);

            // When the script is ready, it calls the global fbAsyncInit function
            return new _promise2.default(function (resolve) {
                window.fbAsyncInit = function () {
                    if (window.FB) {
                        // If for ananoymous addons that cancel FB
                        FB.init({
                            appId: _this2.props.fbAppId,
                            status: true,
                            cookie: true,
                            xfbxml: true,
                            oauth: true,
                            version: _this2.props.fbVersion
                        });
                    }

                    resolve();
                };
            });
        }
    }]);
    return I18nWebProvider;
}(_I18nProvider3.default);

exports.default = I18nWebProvider;


I18nWebProvider.defaultProps = {
    fbAppId: '1637598386514901',
    asyncGlobalsRequired: true,
    fbVersion: 'v2.5'
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-components/dist/shared/I18nProvider/I18nWebProvider.js
// module id = 1446
// module chunks = 0